import PropertySearch from '../components/PropertySearch';

export default function Sales() {
  return (
    <PropertySearch
      listingType="sale"
      title="Property Sales"
      subtitle="Find Your Perfect Investment"
    />
  );
}
